/**
 * Factories
 *
 * Acceso tipado a los casos de uso. Los componentes usan estas funciones en
 * lugar de tocar el contenedor.
 */

import { container } from '../container';
import type {
  AssignRoleUseCase,
  GetMyRolesUseCase,
  GetUserRolesUseCase,
  InviteUserUseCase,
  ListApplicationsUseCase,
  ListRolesUseCase,
  ListUsersUseCase,
  ResetUserPasswordUseCase,
  RevokeRoleUseCase,
  SaveApplicationUseCase,
  SaveRoleUseCase,
  ToggleApplicationStatusUseCase,
  ToggleRoleStatusUseCase,
  ToggleUserStatusUseCase,
} from '@application/use-cases';
import type { IAuthService } from '@domain/services';

export const getAuthService = (): IAuthService => container.get<IAuthService>('IAuthService');

export const getListApplicationsUseCase = (): ListApplicationsUseCase =>
  container.get<ListApplicationsUseCase>('ListApplicationsUseCase');

export const getSaveApplicationUseCase = (): SaveApplicationUseCase =>
  container.get<SaveApplicationUseCase>('SaveApplicationUseCase');

export const getToggleApplicationStatusUseCase = (): ToggleApplicationStatusUseCase =>
  container.get<ToggleApplicationStatusUseCase>('ToggleApplicationStatusUseCase');

export const getListRolesUseCase = (): ListRolesUseCase =>
  container.get<ListRolesUseCase>('ListRolesUseCase');

export const getSaveRoleUseCase = (): SaveRoleUseCase =>
  container.get<SaveRoleUseCase>('SaveRoleUseCase');

export const getToggleRoleStatusUseCase = (): ToggleRoleStatusUseCase =>
  container.get<ToggleRoleStatusUseCase>('ToggleRoleStatusUseCase');

export const getListUsersUseCase = (): ListUsersUseCase =>
  container.get<ListUsersUseCase>('ListUsersUseCase');

export const getInviteUserUseCase = (): InviteUserUseCase =>
  container.get<InviteUserUseCase>('InviteUserUseCase');

export const getToggleUserStatusUseCase = (): ToggleUserStatusUseCase =>
  container.get<ToggleUserStatusUseCase>('ToggleUserStatusUseCase');

export const getResetUserPasswordUseCase = (): ResetUserPasswordUseCase =>
  container.get<ResetUserPasswordUseCase>('ResetUserPasswordUseCase');

export const getGetUserRolesUseCase = (): GetUserRolesUseCase =>
  container.get<GetUserRolesUseCase>('GetUserRolesUseCase');

export const getGetMyRolesUseCase = (): GetMyRolesUseCase =>
  container.get<GetMyRolesUseCase>('GetMyRolesUseCase');

export const getAssignRoleUseCase = (): AssignRoleUseCase =>
  container.get<AssignRoleUseCase>('AssignRoleUseCase');

export const getRevokeRoleUseCase = (): RevokeRoleUseCase =>
  container.get<RevokeRoleUseCase>('RevokeRoleUseCase');
